import { Component, OnInit } from '@angular/core';
import { MessageConfigService } from 'app/integration/message-config/services/message-config.service';
import { MessageConfig } from 'app/integration/message-config/services/message-config';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  templateUrl: 'message-config.component.html',
})
export class MessageConfigComponent implements OnInit {
  public documentConfig: MessageConfig;
  public loading: boolean;

  constructor(private messageConfigService: MessageConfigService, private alertMessageService: MessageService) {}

  public ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.loading = true;
    this.messageConfigService
      .getDocumentConfig()
      .subscribe((config) => (this.documentConfig = config))
      .add(() => (this.loading = false));
  }

  public save(): void {
    this.messageConfigService.save(this.documentConfig).subscribe(() => {
      this.alertMessageService.success('core.msg.save.success');
      this.loadData();
    });
  }
}
